import { defineStore } from 'pinia';
import {
    LogoModulBackTarget,
    LOGOMODULE_POSSIBLE_STATES,
    LOGOMODULE_TARGET_STATES,
    LogoModuleTargetState
} from "@km/components/logo/ModuleLogoAnimationStates";
import { CLOSED } from "@km/animations/animationFactory";

export const useModuleLogoOpenStateStore = defineStore('moduleLogoOpenState', {
    state: () => ({
        currentState: LOGOMODULE_POSSIBLE_STATES.closed,
        componentstates: {
            library: CLOSED,
            userlibrary: CLOSED,
            list: CLOSED,
            edit: CLOSED,
            color: CLOSED,
            colorShade: CLOSED,
            verwaltung: CLOSED,
            stockLogoLibrary: CLOSED,
            kiLogoLibrary: CLOSED
        } as LogoModuleTargetState
    }),

    getters: {
        getCurrentState: (state) => state.currentState,
        getListState: (state) => state.componentstates.list,
        getEditState: (state) => state.componentstates.edit,
        getColorState: (state) => state.componentstates.color,
        getColorShadeState: (state) => state.componentstates.colorShade,
        getVerwaltungState: (state) => state.componentstates.verwaltung,
        getLibrarystate: (state) => state.componentstates.library,
        getUserLibrarystate: (state) => state.componentstates.userlibrary,
        getStockLogoLibraryState: (state) => state.componentstates.stockLogoLibrary,
        getKiLogoLibraryState: (state) => state.componentstates.kiLogoLibrary
    },

    actions: {
        setCurrentState(newstate: LOGOMODULE_POSSIBLE_STATES) {
            const targetState = LOGOMODULE_TARGET_STATES[newstate];
            this.componentstates.list = targetState.list;
            this.componentstates.edit = targetState.edit;
            this.componentstates.color = targetState.color;
            this.componentstates.colorShade = targetState.colorShade;
            this.componentstates.verwaltung = targetState.verwaltung;
            this.componentstates.library = targetState.library;
            this.componentstates.userlibrary = targetState.userlibrary;
            this.componentstates.stockLogoLibrary = targetState.stockLogoLibrary;
            this.componentstates.kiLogoLibrary = targetState.kiLogoLibrary;
            this.currentState = newstate;
        },

        goUpOneLevel() {
            this.setCurrentState(LogoModulBackTarget[this.currentState]);
        },

        ensureStateIsNotClosed() {
            if(this.currentState === LOGOMODULE_POSSIBLE_STATES.closed) {
                this.setCurrentState(LOGOMODULE_POSSIBLE_STATES.logoverwaltung);
            }
        }
    }
});